// extracted by mini-css-extract-plugin
module.exports = {"SwitchWrapper":"SwitchSequence_SwitchWrapper__Bcg_7","Description":"SwitchSequence_Description__-CBwv"};